import React from 'react';
import { AttachmentPreviewList as StreamAttachmentPreviewList, useMessageInputContext } from 'stream-chat-react';
import isEmpty from 'lodash/isEmpty';

import { FileAttachmentPreview } from './file-attachment-preview';
import { ImageAttachmentPreview } from './image-attachment-preview';

export const AttachmentPreviewList = (props) => {
  const { fileUploads, imageUploads } = useMessageInputContext();
  const hasAttachments = !isEmpty(fileUploads) || !isEmpty(imageUploads);
  return hasAttachments ? (
    <div className="AttachmentPreviewList">
      <StreamAttachmentPreviewList
        {...props}
        FileAttachmentPreview={FileAttachmentPreview}
        ImageAttachmentPreview={ImageAttachmentPreview}
      />
    </div>
  ) : null;
};
